module.exports = __webpack_public_path__ + "static/media/facebook-logo.27238600.svg";